import { followAuthorApi, markArticleReadApi, markArticleUnreadApi, unfollowAuthorApi } from "../api";
import { toArticleKey } from "../collections";
import { items } from "./items";

/** Aliases of the followed authors; empty when signed out. */
export const getFollowing = (forceRefresh = false): Promise<string[]> => items.following.get(forceRefresh);

export const followAuthor = async (alias: string): Promise<void> => {
  await followAuthorApi.invoke({ alias });
  const following = await items.following.get();
  if (!following.includes(alias)) {
    items.following.set([...following, alias]);
  }
};

export const unfollowAuthor = async (alias: string): Promise<void> => {
  await unfollowAuthorApi.invoke({ alias });
  const following = await items.following.get();
  items.following.set(following.filter((a) => a !== alias));
};

/** "authorAlias:articleId" of every read article; empty when signed out. Cached for a day. */
export const getReadArticleKeys = (forceRefresh = false): Promise<string[]> => items.articlesRead.get(forceRefresh);

export const markArticleRead = async (alias: string, articleId: string): Promise<void> => {
  await markArticleReadApi.invoke({ alias, articleId });
  const read = await items.articlesRead.get();
  const key = toArticleKey(alias, articleId);
  if (!read.includes(key)) {
    items.articlesRead.set([...read, key]);
  }
};

export const markArticleUnread = async (alias: string, articleId: string): Promise<void> => {
  await markArticleUnreadApi.invoke({ alias, articleId });
  const read = await items.articlesRead.get();
  const key = toArticleKey(alias, articleId);
  items.articlesRead.set(read.filter((k) => k !== key));
};
